var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('div',{staticClass:"logo"}),_c('ul',{staticClass:"nav"},[_c('li',[_c('span',{on:{"click":function($event){return _vm.$router.push('/m/index')}}},[_vm._v("Home")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }